import ReducersFactory from '../../lib/reducers/ReducersFactory';
import { QUESTIONNAIRE_DEFAULT } from '../constants/initStateItems';

const questionnaire = new ReducersFactory('questionnaire', [], QUESTIONNAIRE_DEFAULT)


export default questionnaire.reducer